<script setup lang="ts">
import {PropType} from "vue";

defineProps({
  input: {
    type: Object as PropType<String>,
    default: '',
  },
})
</script>

<template>
  <div v-html="input"></div>
</template>

<style scoped>

</style>
